module.exports = __webpack_public_path__ + "img/4w1.156601f8.jpg";